import { oldValueStyles } from 'app/shared/styles/valueDiff.styles';

export const rootStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  paddingTop: '24px',
  paddingBottom: '24px',
};

export const headerStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'baseline',
  gap: '4px 12px',
};

export const stateStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px',
  padding: '32px 16px',
};

export const commentTextStyles = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};

const wrappingCellStyles = {
  verticalAlign: 'top',
  whiteSpace: 'normal',
  '.table-cell__content_box': {
    minWidth: 0,
  },
};

export const getWrappingCellStyles = () => wrappingCellStyles;

export const struckOutTextStyles = {
  ...oldValueStyles,
  color: 'inherit',
};
